<template>
  <div>
    <uploader
      :id="getId()"
      :options="options"
      :files="files"
      :disabled="disabled"
      :can-delete="canModify"
      :can-upload="canModify"
      @uploaded="onFileUploaded"
      @uploading="
        (uploaderId, isUploading) => $emit('uploading', uploaderId, isUploading)
      "
      @deleted="deletedFile"
      @imageDataUrl="onImageDataUrl"
      @status="onStatus"
    >
    </uploader>
    <input v-if="name.length" type="hidden" :name="name" :value="fileToken" />
  </div>
</template>

<script>
import Uploader from '../Uploader/Uploader';
import Field from './Field';
import { mapMutations, mapGetters, mapState } from 'vuex';
const toastr = require('toastr');

export default {
  components: {
    Uploader
  },
  extends: Field,
  inject: ['lang'],
  props: {
    foreignId: {
      type: Number,
      default: null
    },
    name: {
      type: String,
      default: ''
    },
    resourceSlug: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      imageDataUrl: null,
      fileToken: null,
      file: null
    };
  },
  computed: {
    tmpFileId() {
      return this.field.id + '-' + this.foreignId;
    },
    files() {
      if (this.file) {
        return [JSON.parse(this.file)];
      } else {
        const tmpFile = this.tempFile(this.tmpFileId);
        return tmpFile ? [tmpFile] : [];
      }
    },
    options() {
      let obj = JSON.parse(this.field.uploaderOptions);
      if (obj.foreignId === null) {
        if (this.foreignId === null) {
          delete obj.foreignId;
        } else {
          obj.foreignId = this.foreignId;
        }
      }

      return obj;
    },
    role() {
      return this.isManager ? 'manager' : 'entrant';
    },
    resource() {
      return this.field.resource;
    },
    canModify() {
      return !this.locks.readOnly;
    },
    ...mapGetters('entryForm', ['tempFile', 'entrySlug']),
    ...mapState('entryForm', ['locks'])
  },
  created() {
    this.fileToken = this.value;
    this.file = this.field.file;
  },
  beforeDestroy()
  {
    this.storeFiles({
      file: null,
      id: this.tmpFileId
    });
  },
  methods: {
    async deletedFile(id, remoteId, isNotCaption) {
      const deleteResult = await this.deleteFileRequest(remoteId);
      if (deleteResult && isNotCaption) {
        this.storeFiles({
          file: null,
          id: this.tmpFileId,
          fieldId: this.field.id
        });
        this.file = null;
      }
    },
    onImageDataUrl(imageDataUrl, file) {
      this.imageDataUrl = imageDataUrl;
      this.storeFiles({
        file: { ...file, image: imageDataUrl },
        id: this.tmpFileId
      });
    },
    onStatus(statusMessage) {
      let file = this.tempFile(this.foreignId);
      this.storeFiles({
        file: { ...file, status: statusMessage },
        id: this.tmpFileId
      });
    },
    deleteFileUrl(fileId) {
      switch (this.resource) {
        case 'Entries':
          return (
            '/entry/' + this.role + '/' + this.entrySlug + '/file/' + fileId
          );
        case 'Users':
          return '/user/' + this.resourceSlug + '/file/' + fileId;
        default:
          return null;
      }
    },
    deleteFileRequest(fileId) {
      const deleteUrl = this.deleteFileUrl(fileId);
      if (deleteUrl) {
        return this.$http
          .delete(this.deleteFileUrl(fileId))
          .then(() => true)
          .catch(error => {
            if (error.response.data.error) {
              toastr.error(error.response.data.error);
            } else {
              toastr.error(document.getElementById('alerts-generic').innerHTML);
            }
            return false;
          });
      }
    },
    onFileUploaded(value, file) {
      this.fileToken = value;
      this.onInput(value);
      this.storeFiles({
        file: file ? JSON.stringify(this.modifyFile(file)) : null,
        id: this.tmpFileId,
        fieldId: this.field.id
      });
    },
    
    modifyFile(file) {
      return {...file, id: file.remoteId, image: this.imageDataUrl}
    },
    ...mapMutations('entryForm', ['storeFiles'])
  }
};
</script>
